import { SVGProps } from 'react';

export const ChevronDownStroke = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M5.58594 2.36328L10 6.77734L11.1719 5.58594L5.58594 -4.88338e-07L1.04156e-07 5.58594L1.17188 6.77734L5.58594 2.36328Z"
        fill="currentColor"
      />
    </svg>
  );
};
